import React, { useEffect, useRef } from 'react';

function BuildLogs({ logs, className = '' }) {
    const containerRef = useRef(null);

    // Build output is untrusted text (it echoes flavor files and tool output), so escape it
    // before adding the link and line-break markup.
    const escapeHtml = (text) => text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const formatLogs = (logs) => {
        return escapeHtml(logs)
            .replace(/(https:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>')
            .replace(/\n/g, '<br />');
    };

    useEffect(() => {
        // Scroll ke bawah dalam container log (bukan halaman)
        if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    }, [logs]);

    return (
        <div
            ref={containerRef}
            className={`log ${className}`.trim()}
        >
            <div dangerouslySetInnerHTML={{ __html: formatLogs(logs) }} />
        </div>
    );
}

export default BuildLogs;
